export default __webpack_public_path__ + "static/media/701.8b74dff3.png";